<template>
  <div class="o-rewards">
    <app-navigation :current-space="$t('web.rewards_results.nav_space')" :back-button="true"></app-navigation>


    <main class="o-rewards__main">
      <search-bar></search-bar>
      <rewards-navigation></rewards-navigation>

      <loading-icon v-if="rewardsLoading"></loading-icon>
      <rewards-list v-else></rewards-list>

      <paginate
        v-show          = "!rewardsLoading"
        :pagination     = "pagination"
        :pagingCallback = "goToPage"
      ></paginate>
    </main>


    <app-footer></app-footer>
  </div>
</template>




<script>
import { clone, merge } from 'lodash'
import Paginate from '@/views/components/shared/Paginate'
import RewardsList from '@/views/components/catalog/RewardsList'
import RewardsNavigation from '@/views/components/catalog/RewardsNavigation'
import SearchBar from '@/views/components/catalog/SearchBar'
import util from '@/functions'

export default {
  name: 'RewardsResults',

  components: {
    Paginate,
    RewardsList,
    RewardsNavigation,
    SearchBar
  },

  data () {
    return { rewardsLoading: true }
  },

  computed: {
    pagination () {
      if (this.$store.getters.rewards.pagination === null) {
        return {}
      }
      // FIXME This shouldn't modify state through a getter. It should instead
      //       commit a mutation or dispatch an action.
      this.$store.getters.rewards.pagination.pages = util.getPagination(this.$store.getters.rewards.pagination.current, this.$store.getters.rewards.pagination.pages)
      return this.$store.getters.rewards.pagination
    }
  },

  watch: {
    '$route.query' (newQuery) {
      this.getRewards(newQuery)
    }
  },

  methods: {
    /**
     * Get rewards matching the passed query.
     *
     * @param {object} query
     * @return {void}
     */
    getRewards (query) {
      this.rewardsLoading = true
      this.$store.dispatch('GET_REWARDS', query)
        .then(() => {
          this.rewardsLoading = false
        })
        .catch(error => Promise.reject(error))
    },

    /**
     * Go to the specified page of paginated results.
     *
     * @param {number} pageNumber
     * @return {void}
     */
    goToPage (page) {
      this.$router.push({
        name: 'Rewards Results',
        query: merge(clone(this.$route.query), { page: page })
      })
    }
  },

  created () {
    this.$store.dispatch('LOAD_PARTICIPANT', this.$router).catch(error => Promise.reject(error))
    this.getRewards(this.$route.query)
  }
}
</script>



// WEBPACK FOOTER //
// RewardsResults.vue?7e742048